"use client";
import {
  getCourseCatalog,
} from "@/lib/courseData";
import { useEffect } from "react";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import Loading from "@/app/components/Loading";

export default function CitadelCoursePage() {
  const locale = useLocale();
  const router = useRouter();

  useEffect(() => {
    const redirectToLesson = async () => {
      const catalogResult = await getCourseCatalog(locale);
      
      // 提取所有课程，避免重复 flatMap 操作
      const allLessons = catalogResult.data.flatMap((chapter: any) => chapter.lessons);
      
      // 优先选择第一个解锁、未完成的课程
      const firstIncomplete = allLessons.find((l: any) => !l.locked && !l.completed);
      if (firstIncomplete) {
        router.replace(`/products/citadel/course/${firstIncomplete.id}`);
        return;
      }
      
      // 否则选择最后一个完成的课程
      const lastCompleted = allLessons.findLast((l: any) => l.completed);
      if (lastCompleted) {
        router.replace(`/products/citadel/course/${lastCompleted.id}`);
        return;
      }
    };

    redirectToLesson();
  }, [locale, router]);

  // 显示加载状态直到重定向完成
  return <Loading />;
}
